import { apiClient } from './apiClient';

export interface GroupsFirstPageResponse {
  data: any[];
  hasMore: boolean;
  currentPage: number;
  totalLoaded: number;
}

export interface GroupsRemainingPagesResponse {
  data: any[];
  hasMore: boolean;
  lastPage: number;
  totalLoaded: number;
}

/**
 * Get first page of groups (fast loading)
 */
export async function getGroupsFirstPage(queryParams?: Record<string, string>): Promise<GroupsFirstPageResponse> {
  const params = { initial: 'true', ...queryParams };
  return apiClient.get<GroupsFirstPageResponse>('/groups', { params });
}

/**
 * Get remaining pages of groups (background loading)
 */
export async function getGroupsRemainingPages(startPage: number = 2, queryParams?: Record<string, string>): Promise<GroupsRemainingPagesResponse> {
  const params = { startPage: startPage.toString(), ...queryParams };
  return apiClient.get<GroupsRemainingPagesResponse>('/groups', { params });
}

/**
 * Get all groups (legacy - not recommended for large datasets)
 */
export async function getGroups(queryParams?: Record<string, string>): Promise<any[]> {
  return apiClient.get<any[]>('/groups', { params: queryParams });
}

/**
 * Get detailed information for a specific group by ID with first page of members only (fast loading)
 */
export async function getGroupProfileFirstPage(groupId: string): Promise<any> {
  return apiClient.get<any>(`/groups/${groupId}`, { params: { initial: 'true' } });
}

/**
 * Get remaining pages of group members (background loading)
 */
export async function getGroupMembersRemainingPages(groupId: string, startPage: number = 2): Promise<any> {
  return apiClient.get<any>(`/groups/${groupId}/members`, { params: { startPage: startPage.toString() } });
}

/**
 * Get detailed information for a specific group by ID (legacy - loads all members at once)
 */
export async function getGroupProfile(groupId: string): Promise<any> {
  return apiClient.get<any>(`/groups/${groupId}`);
}
